import "./NoteBox.css";

const NoteBox = (props) => {
  return(
    <div className={"note-box-wrapper" + (props.equation ? " equation" : "")}>
      <div className="note-box">
        {props.children}
      </div>
    </div>
  );
}

export default NoteBox;